module.exports = __webpack_public_path__ + "img/75656.169d99a2.svg";